export default {
    linkList : {
        "operationPolicy": "Kebijakan Operasional",
        "communityPolicy": "Kebijakan Komunitas",
        "youthProtectionPolicy": "Kebijakan Perlindungan Anak dan Remaja",
        "declarationOfSafety": "Deklarasi KeMOanan",
        "cookiePolicy": "Kebijakan Cookie",
        "customerSupport": "Layanan Pelanggan",
        "guaranteeOfRights": "Hak Subjek Data",
        "privacyPolicy": "Kebijakan Privasi",
        "termsOfService": "Persyaratan Layanan",
        "companyLink": "Tentang Perusahaan",
        "doNotSell": "Do Not Sell My Personal Information",
        "gameGrade": "게임이용등급",
        "communityPolicyView": "커뮤니티정책",
        "servicePolicy": "서비스정책",
        "termsOfUse": "회원정책",
        "operationPolicyNCJ": "운영방침",
    },
    footerWords:{
        "gameRelatedLaw": "Informasi Tambahan Sesuai Undang-Undang Terkait Game",
        "brandInformation": "Informasi Nama Perusahaan",
        "copyright": "Hak Cipta",
        "channelingInfo": "NCSOFT Corporation hanya bertindak sebagai mediator dalam menyediakan channeling game dalam plaync. NCSOFT Corporation tidak menangani langsung penyediaan layanan game maupun transaksi elektronik pada game tersebut.<br>Kewajiban dan tanggung jawab yang berkaitan dengan layanan dari channeling game ada pada perusahaan masing-masing game. NCSOFT Corporation tidak bertanggung jawab atas masalah yang terjadi berkaitan dengan game tersebut."
    },
    infoCS:{
        "businessInformation": "Periksa Informasi Bisnis",
        "infoAddress": "NCSOFT Corporation CEO Kim Taek-jin Nomor Register Perusahaan 144-85-04244 Nomor Pendaftaran Perusahaan Perdagangan Elektronik 2013-Gyeonggi Seongnam-No. 1268",
        "infoEmail": "Email",
        "mobile": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1566-7004 FAX: +82-2-2186-3499",
        "pc": "",
        "other": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 (Game PC), +82-1566-7004 (Game Mobile) FAX: +82-2-2186-3550 (Game PC), +82-2-2186-3499 (Game Mobile)",
        "none": '',

        "infoEmail-mobile": "MobileCS@ncsoft.com",
        "infoEmail-pc": "credit@ncsoft.com",
        "infoEmail-other": "credit@ncsoft.com/(Game PC)/MobileCS@ncsoft.com/(Game Mobile)",
        "infoEmail-none": "",
    },
    infoJP:{
        "jpReleaseDayValue_LW": "04 Novemver 2021",
        "jpReleaseDay": "Tanggal Rilis",
        "jpDevelopedBy": "Developer/Operator",
        "jpOs": "Sistem Operasi",
        "jpPriceValue": "Gratis (termasuk pembelian dalam aplikasi)",
        "jpPrice": "Harga",
        "jpGenre": "Genre",
        "jpTitle": "Judul",
    },
    "country": {
        "HK": "Hong Kong",
        "PH": "Filipina",
        "TH": "Thailand",
        "QA": "Qatar",
        "JP": "Jepang",
        "ID": "Indonesia",
        "AE": "Uni Emirat Arab",
        "SG": "Singapura",
        "SA": "Arab Saudi",
        "MY": "Malaysia",
        "RU": "Rusia",
        "TW": "Taiwan",
        "KR": "Republik Korea",
        "UA": "Ukraina",
        "BY": "Belarus",
        "LT": "Lituania",
        "PL": "Polandia",
        "GR": "Yunani",
        "IL": "Israel",
        "KW": "Kuwait",
        "AT": "Austria",
        "US": "Amerika Serikat",
        "CA": "Kanada",
        "DE": "Jerman",
        "GB": "Britania Raya",
        "FR": "Prancis",
        "BR": "Brasil",
        "IT": "Italia",
        "ES": "Spanyol",
        "CL": "Chili",
        "NO": "Norwegia",
        "SE": "Swedia",
        "IE": "Irlandia",
        "PT": "Portugal",
        "FI": "Finlandia",
        "DK": "Denmark",
        "CH": "Swiss",
        "AR": "Argentina",
        "PE": "Peru",
        "MX": "Meksiko",
        "KZ": "Kazakstan",
        "UZ": "Uzbekistan",
        "AZ": "Azerbaijan",
        "GE": "Georgia",
        "MD": "Moldova",
        "AM": "Armenia",
        "MO": "Makau",
        "NC": "Global"
    }
};
